import React, {
    Component
} from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import {
    AlertPopup
} from './../PopUp/AlertPopup';
import data_tab from './_tab_1';
import unit_tab from './_tab_2';
import warehouse_tab from './_tab_3';
import barcode_tab from './_tab_4';
import goods_tab from './_tab_5';
import { INSCorServicePost } from './../_getjson';

require('./stylemain.css');


export default class Home extends Component {
    state = {
        navACKey: "0",
        showResults: 0,
        isHidden: true,
        itemcode: "",
        olditemcode: "",
        THname: "",
        ENname: "",
        dataunit: "",
        datawarehouse: "",
        datatab: "",
        databarcode: "",
        dataProductset: "",
        stockunit: "",
        saleunit: "",
        pounit: "",
        // userfields
        cahsPrice: "0.00",
        dnSum: "0.00",
        dnMoney: "0.00",
        periodPrice: "0.00",
        period: "0.00",
        producedby: "0.00",
        rn_regist: "0.00",
        dateRegist: "",

        showPopup: false,
    }

    onSave = () => {
        if (typeof this.state.dataunit.tableData === 'undefined') {
            AlertPopup("Warning", "กรุณาตรวจสอบความถูกต้องของหน่วยนับ!");
        } else if (typeof this.state.datawarehouse.tableData_w === 'undefined') {
            AlertPopup("Warning", "กรุณาตรวจสอบความถูกต้องของคลังสินค้า!");
        } else {
            const parameter = new URLSearchParams();
            parameter.append("jwt", localStorage.getItem('Token'));
            parameter.append("CREATEUSER", localStorage.getItem('Username'));
            parameter.append("CODE", this.state.itemcode);
            parameter.append("OLDCODE", this.state.olditemcode);
            parameter.append("NAMETH", this.state.THname);
            // group in put in data_tab
            parameter.append("MAINGROUP", this.state.datatab.group);
            parameter.append("SUBGROUP1", this.state.datatab.typeproduct);
            parameter.append("SUBGROUP2", this.state.datatab.brandname);
            parameter.append("SUBGROUP3", this.state.datatab.model);
            parameter.append("SUBGROUP4", this.state.datatab.color);
            parameter.append("SUBGROUP5", this.state.datatab.grade);
            // กลุ่มบัญชี
            parameter.append("ACCGRPCODE", this.state.datatab.accountgroup);
            //กลุ่มชื่อย่อสินค้า
            parameter.append("DIMENSION1", this.state.datatab.shortname);
            parameter.append("DIMENSION2", this.state.datatab.provincialregister);
            parameter.append("DIMENSION3", this.state.datatab.sticker);
            parameter.append("DIMENSION4", this.state.datatab.cash);
            // serial number  
            parameter.append("SerialFlag", this.state.datatab.serialNumber);
            parameter.append("COSTTYPE", this.state.datatab.costtype);
            parameter.append("TAXTYPE", this.state.datatab.taxcalculation);
            parameter.append("STOCKTYPE", this.state.datatab.category);
            //การใช้งาน 
            parameter.append("CLOSEFLAG", this.state.datatab.usability);

            parameter.append("STOCKUNIT", this.state.dataunit.countunitStock);
            parameter.append("SALEUNIT", this.state.datawarehouse.unitsdefaultreceiving);
            parameter.append("POUNIT", this.state.datawarehouse.unitdefaulpay);
            parameter.append("STOCKPROC", this.state.datatab.sellminus);
            //GRWAREHOUSE
            parameter.append("GRWAREHOUSE", this.state.datawarehouse.defaultlibrary);
            parameter.append("GRLOCATION", this.state.datawarehouse.getstartedpendleton);
            parameter.append("GIWAREHOUSE", this.state.datawarehouse.defaularchives);
            parameter.append("GILOCATION", this.state.datawarehouse.defaulpayposition);
            parameter.append("PURCHASEORDER", 0.00000);
            parameter.append("CUSTORDER", 0.00000);
            parameter.append("SALEORDER", 0.00000);
            parameter.append("POPOINT", 0.00000);

            //**userfileds */
            parameter.append("CAHSPRICE", this.state.datatab.cahsPrice);
            parameter.append("DNSUM", this.state.datatab.dnSum);
            parameter.append("DNMoney", this.state.datatab.dnMoney);
            parameter.append("PeriodPrice", this.state.datatab.periodPrice);
            parameter.append("Period", this.state.datatab.period);
            parameter.append("Producedby", this.state.datatab.producedby);
            parameter.append("Rn_regist", this.state.datatab.rn_regist);
            parameter.append("DateRegist", this.state.datatab.dateRegist);
            /// ข้อมูลในตาราง-------------หน่วยนับ----------------------------- 
            var unititem = this.state.dataunit.tableData;
            var unitArr = [];
            for (let index = 0; index < unititem.length; index++) {
                //  console.log(index); 
                if ((unititem[index].C1 !== "") && (unititem[index].C3 !== "") && (unititem[index].C4 !== "") && (unititem[index].C4 !== "")) {
                    let close_ = "";
                    if (unititem[index].C4 === "เปิด") {
                        close_ = 0;
                    } else {
                        close_ = 1;
                    }
                    unitArr[index] = unititem[index].C1_insert + "," + unititem[index].C3 + "," + close_;
                    parameter.append("STOCKUNIT_ARR", unitArr[index]);
                }
            }
            parameter.append("STOCKQTY", 0.0000);
            parameter.append("TRFLAG", 0);
            // console.log('================unitArr====================\n'+unitArr);  
            var wherehoseitem = this.state.datawarehouse.tableData_w;
            var wherehoseArr = [];
            for (let index = 0; index < wherehoseitem.length; index++) {

                if ((wherehoseitem[index].C1_insert !== "") && (typeof wherehoseitem[index].C2_insert !== "undefined") && (typeof wherehoseitem[index].C3_insert !== "undefined") && (typeof wherehoseitem[index].C4 !== "undefined")) {
                    let close_ = "";
                    if (wherehoseitem[index].C4 === "เปิด") {
                        close_ = 0;
                    } else if (wherehoseitem[index].C4 === "ปิด") {
                        close_ = 1;
                    }
                    wherehoseArr[index] = wherehoseitem[index].C1_insert + "," + wherehoseitem[index].C2_insert + "," + wherehoseitem[index].C3_insert + "," + close_;
                    parameter.append("WAREHOUSE", wherehoseArr[index]);
                }
            }

            //--------------------------------[บาร์โค้ด]--------------------------------------------------------------------
            var barcodeitem = this.state.databarcode.barcodeTable;
            var barcodeArr = [];
            for (let index = 0; index < barcodeitem.length; index++) {
                if ((barcodeitem[index].C1 !== "") && (barcodeitem[index].C2 !== "") && (barcodeitem[index].C3 !== "") && (barcodeitem[index].C4 !== "")) {
                    barcodeArr = barcodeitem[index].C1 + "," + barcodeitem[index].C2 + "," + barcodeitem[index].C3 + "," + barcodeitem[index].C4;
                    parameter.append("BARCODE_ARR", barcodeArr);
                }
            }

            // parameter.append("PRODUCTSET_ARR", barcodeArr);
            //------------------------ชุดสินค้า---------------------------
            var productsset = this.state.dataProductset.tableproducts;
            var productssetArr = [];
            for (let index = 0; index < productsset.length; index++) {
                if ((productsset[index].C1 !== "") && (productsset[index].C2 !== "") && (productsset[index].C3 !== "") && (productsset[index].C4 !== "")) {
                    productssetArr = productsset[index].C1 + "," + productsset[index].C2 + "," + productsset[index].C3 + "," + productsset[index].C4 + "," + productsset[index].C5 + "," + productsset[index].C6 + "," + productsset[index].C7;
                    parameter.append("PRODUCTSET_ARR", productssetArr);
                }
            }
            parameter.append("TYPEPRODUCTSET", this.state.dataProductset.typeset);
            // parameter.append("hploannet",this.state.products[value].Priceloannet);
            for (let p of parameter) {
                console.log(p)
            }


            var Url = "ICSPRODUCT/Save";
            INSCorServicePost(Url, parameter).then(res => {
                if (res.data === 1) {
                    AlertPopup('Success', "บันทึกสำเร็จ");
                    setTimeout(() => {
                        this.componentDidMount();
                    }, 50);
                } else {
                    AlertPopup('Error', "เกิดข้อผิดพลาด");
                }
                console.log(res);
            });
        }
    }
    onNew = () => {
        console.log('====================================');
        console.log();
        console.log('====================================');
    }

    inputonChange = (type, value) => {
        switch (type) {
            case "itemcode":
                this.setState({
                    itemcode: value.target.value
                });
                break;
            case "olditemcode":
                this.setState({
                    olditemcode: value.target.value
                });
                break;
            case "THname":
                this.setState({
                    THname: value.target.value
                });
                break;
            case "ENname":
                this.setState({
                    ENname: value.target.value
                });
                break;
            default: break;
        }
    }
    Getdata = (from, value) => {
        switch (from) {
            case "dataunit":
                this.setState({
                    dataunit: value
                });
                break;
            case "datawarehouse":
                this.setState({
                    datawarehouse: value
                });
                break;
            case "datatab":
                this.setState({
                    datatab: value
                });
                break;
            case "databarcode":
                this.setState({
                    databarcode: value
                });
                break;
            case "dataproducts":
                this.setState({
                    dataProductset: value
                });
                break;
            default: break;
        }
        //  setTimeout(() => {console.log(this.state.dataunit);}, 50);
    }
    handleSelect(eventKey) {
        this.setState({
            navACKey: eventKey,
            showResults: eventKey
        });
        if (this.state.eventKey === 0) {
            this.setState({
                isHidden: true
            });
        } else {
            this.setState({
                isHidden: false
            });
        }
    }

    //**************************************************************************popup**************************************************************************************/
    togglePopup() {
        this.setState({
            showPopup: !this.state.showPopup
        });
    }
    _getpopppUserFields = (data) => {
        console.log(data);
    }
    render() {
        return (
            <div class="Inven">
                <nav class="navbar navbar-dark bg-primary ">
                    <div class="flex-list">
                        <ul class="nav navbar-nav">
                            <li onClick={this.onSave}><i class="far fa-save"></i> บันทึก </li>
                            <li onClick={this.onNew}>  <i class="far fa-file"></i> ใหม่ </li>
                            <li><i class="far fa-trash-alt"></i> ลบ</li>
                            <span className="pipe"></span>
                            <li><i class="fas fa-print"></i> พิมพ์</li>
                            <li><button type="button" class="btn " onClick={() => { window.location.href = 'home' }} tabIndex="85"><i class="fas fa-sign-out-alt"></i></button></li>

                        </ul>
                    </div>
                </nav>
                <div class="container">
                    <div class="container-fluid col-xs-12 col-sm-12  col-md-12 col-lg-6">
                        <hr />
                        <div class="row">
                            <div class="form-group col-xs-12 col-sm-6 col-lg-6 col-md-6">
                                <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span class="input-group-addon">รหัสสินค้า : </span>
                                    <input id="itemcode" type="text" class="form-control " name="itemcode" onChange={this.inputonChange.bind(null, "itemcode")} tabIndex="1" />

                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-6 col-lg-6 col-md-6">
                                <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span class="input-group-addon">รหัสสินค้าเก่า : </span>
                                    <input id="olditemcode" type="text" class="form-control " name="olditemcode" onChange={this.inputonChange.bind(null, "olditemcode")} tabIndex="2" />

                                </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                <div class="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span class="input-group-addon"> ชื่อสินค้าภาษาไทย :</span>
                                    <input id="id1" type="text" class="form-control " onChange={this.inputonChange.bind(null, "THname")} tabIndex="3" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <Nav bsStyle="tabs" activeKey={this.state.navACKey} className="Inventory" onSelect={k => this.handleSelect(k)}>
                        <NavItem eventKey="0" >ข้อมูล</NavItem>
                        <NavItem eventKey="1" >หน่วยนับ</NavItem>
                        <NavItem eventKey="2" >คลังสินค้า</NavItem>
                        <NavItem eventKey="3" >บาร์โค้ด</NavItem>
                        <NavItem eventKey="4" >สินค้าชุด</NavItem>
                    </Nav>
                    <div>
                        <data_tab Inventory={this.state} Getdata={this.Getdata} />
                        <unit_tab Inventory={this.state} Getdata={this.Getdata} />
                        <warehouse_tab Inventory={this.state} Getdata={this.Getdata} />
                        <barcode_tab Inventory={this.state} sendData={this.state.dataunit} Getdata={this.Getdata} />
                        <goods_tab Inventory={this.state} Getdata={this.Getdata} />
                    </div>
                </div>
            </div>
        )
    }
}
